import { get } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

export const workerBadgeSchema = z.object({
  type: z.literal("workerBadge"),
  id: z.string(),
  attributes: z.object({
    name: z.string(),
    viewedAt: z.coerce.date().optional(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  }),
});

export const getWorkerBadgesResponseSchema = z.object({
  data: z.array(workerBadgeSchema),
  relationships: z.object({
    worker: z.object({
      data: z.object({
        type: z.literal("worker"),
        id: z.string(),
      }),
    }),
  }),
});

export type WorkerBadge = z.infer<typeof workerBadgeSchema>;
export type WorkerBadgesResponse = z.infer<typeof getWorkerBadgesResponseSchema>;

export const GET_WORKER_BADGES_PATH = "/workers/:workerId/badges";

export function useGetWorkerBadges(
  workerId: string,
  options: UseQueryOptions<WorkerBadgesResponse> = {}
): UseQueryResult<WorkerBadgesResponse> {
  return useQuery({
    queryKey: [GET_WORKER_BADGES_PATH, workerId],
    queryFn: async () => {
      const response = await get<undefined, WorkerBadgesResponse>({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}${GET_WORKER_BADGES_PATH.replace(
          ":workerId",
          workerId
        )}`,
        responseSchema: getWorkerBadgesResponseSchema,
      });

      return response.data;
    },
    ...options,
  });
}
